import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { MediaQuery } from '../../../shared/constants/Styles';
import { Typography } from '../../../shared/constants/Typographies';

export const Newsletter = styled.div`
  text-align: center;
  margin: ${({ isFullScreen }) => (isFullScreen ? '100px 0' : '0')};
  transform: ${({ hasIllustration }) => hasIllustration && `translateY(-50px)`};

  ${MediaQuery.S_AND_DOWN} {
    margin: 0;
    transform: ${({ hasIllustration }) =>
      hasIllustration && `translateY(-25px)`};
  }

  input {
    width: 300px;
    margin: 0 15px 0 0;

    ${MediaQuery.S_AND_DOWN} {
      margin: 0 0 15px 0;
    }
  }
`;

export const PictureContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
`;

export const Title = styled.h2`
  ${Typography.XXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0 0 25px 0;

  ${MediaQuery.S_AND_DOWN} {
    margin: 0 0 15px 0;
  }
`;

export const BigTitle = styled.h1`
  ${Typography.XXXXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0 0 25px 0;

  ${MediaQuery.S_AND_DOWN} {
    margin: 0 0 15px 0;
  }
`;

export const Description = styled.p`
  ${Typography.M};
  margin: auto;
  width: 370px;
  color: ${Color.DOLPHIN};

  ${MediaQuery.S_AND_DOWN} {
    width: auto;
    padding: 0 30px 0 30px;
  }
`;

export const Wrapper = styled.form`
  margin-top: 30px;
  display: inline-flex;

  ${MediaQuery.S_AND_DOWN} {
    margin-top: 15px;
    display: block;
  }
`;
